export default __webpack_public_path__ + "assets/ad1fcd55bcd54456b948d268629b8f6d.png";